import React from "react";
import ClientCards from "../../components/ClientCards/ClientCards";
import "./ContactUs.css";
import PhoneIcon from "../../assets/icons/PhoneIcon.svg";
import EmailIcon from "../../assets/icons/EmailIcon.svg";
import LocationIcon from "../../assets/icons/LocationIcon.svg";
import ClockIcon from "../../assets/icons/ClockIcon.svg";
import ArrowUp from "../../assets/icons/ArrowUp.svg";
import WartsilaLogo from "../../assets/images/Wartsila.png";
import BarrelmanLogo from "../../assets/images/Barrelman.jpg";
import PlaceholderLogo from "../../assets/images/Placeholder.svg";

interface ContactUsProps {
  scrollTo: (section: any) => void;
  partnerWithUsRef: React.MutableRefObject<HTMLDivElement | null>;
  ourServicesRef: React.MutableRefObject<HTMLDivElement | null>;
  fleetDetailsRef: React.MutableRefObject<HTMLDivElement | null>;
  aboutUsRef: React.MutableRefObject<HTMLDivElement | null>;
  contactUsRef: React.MutableRefObject<HTMLDivElement | null>;
  missionVisionRef: React.MutableRefObject<HTMLDivElement | null>;
  hearFromOurClientsRef: React.MutableRefObject<HTMLDivElement | null>;
}

const ContactUs = (props: ContactUsProps) => {
  return (
    <section 
      className="contact-us-container" 
      id="contactUs" 
      ref={props.contactUsRef}
    >
      {/* Top Section: Clients Grid */}
      <div className="contact-us-top-container">
        <h1>
          JJJM's <label className="contact-us-clients-label">Clients</label>
        </h1>

        <div className="contact-us-clients-wrapper">
          {/* Row 1 */}
          <div className="contact-us-client-cards-container">
            <ClientCards
              clientName="Barrelman Corporation"
              clientAddress="Sucat, Parańaque"
              logo={BarrelmanLogo}
            />

            <ClientCards
              clientName="Wartsila Philippines, Inc."
              clientAddress="Cabuyao, Laguna"
              logo={WartsilaLogo}
            />

            <ClientCards
              clientName="Net Center Logistics Corp."
              clientAddress="San Juan, Metro Manila"
              logo={PlaceholderLogo}
            />
          </div>

          {/* Row 2 */}
          <div className="contact-us-client-cards-container">
            <ClientCards
              clientName="CSP Brokerage"
              clientAddress="UN Ave, Manila"
              logo={PlaceholderLogo}
            />

            <ClientCards
              clientName="Blue Mountains Worldwide Distribution Inc."
              clientAddress="Philippines"
              logo={PlaceholderLogo}
            />

            <ClientCards
              clientName="Link Asia Forwarding Solutions Corp."
              clientAddress="Philippines"
              logo={PlaceholderLogo}
            />
          </div>

          {/* Row 3 */}
          <div className="contact-us-client-cards-container">
            <ClientCards
              clientName="Teleport Commerce Philippines Inc."
              clientAddress="Philippines"
              logo={PlaceholderLogo}
            />

            <ClientCards
              clientName="Airtropolis Consolidator Phils. Inc."
              clientAddress="Philippines"
              logo={PlaceholderLogo}
            />
          </div>
        </div>
      </div>

      {/* Bottom Section: Get in Touch & Navigation Links */}
      <div className="contact-us-bottom-container">
        <div className="contact-us-row contact-content-row">
          <div className="get-in-touch-wrapper">
            <div className="get-in-touch-container">
              <h1>Get in touch</h1>
            </div>
            <div className="contact-us-icon-with-label-container">
              <img src={PhoneIcon} alt="Phone" />
              <label>+63 495 302217</label>
            </div>
            <div className="contact-us-icon-with-label-container">
              <img src={EmailIcon} alt="Email" />
              <label>sales@jjjmsun.com</label>
            </div>
            <div className="contact-us-icon-with-label-container">
              <img src={LocationIcon} alt="Location" />
              <label>Block 8 Lot 3 Hongkong Village, Banay-banay Cabuyao</label>
            </div>
            <div className="contact-us-icon-with-label-container">
              <img src={ClockIcon} alt="Clock" />
              <label>
                Office Hours: Monday to Saturday, 8:00 AM to 5:00 PM
              </label>
            </div>
          </div>

          <div className="explore-container">
            <h1>Explore</h1>
            <div className="contact-us-column">
              <a onClick={() => props.scrollTo(props.ourServicesRef)}>
                Trucking Services
              </a>
              <a onClick={() => props.scrollTo(props.fleetDetailsRef)}>
                Fleet Details
              </a>
              <a onClick={() => props.scrollTo(props.hearFromOurClientsRef)}>
                Testimonial and Clients
              </a>
              <a onClick={() => props.scrollTo(props.missionVisionRef)}>
                Mission and Vision
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bar */}
        <div className="contact-us-row space-between footer">
          <div className="contact-us-row footer-left">
            <label className="company-name">JJJM SUN ENTERPRISES</label>
            <label>2024 ALL RIGHTS RESERVED ©</label>
          </div>
          <div className="contact-us-row footer-right">
            <img src={require("../../assets/images/Facebook.png")} alt="Facebook" />
            <a 
              href="https://www.facebook.com/profile.php?id=61563554617129"
              target="_blank"
              rel="noopener noreferrer"
            >
              FOLLOW US ON FACEBOOK!
            </a>
          </div>
        </div>

        {/* Back To Top Button */}
        <button
          className="arrow-up-btn"
          onClick={() => {
            props.scrollTo(props.partnerWithUsRef);
          }}
          aria-label="Scroll to top"
        >
          <img src={ArrowUp} alt="Arrow Up" />
        </button>
      </div>

      {/* Decorative Truck Graphic */}
      <img
        className="truck-image"
        src={require("../../assets/images/Truck3.png")}
        alt="Truck Graphic"
      />
    </section>
  );
};

export default ContactUs;